import { useContext, useEffect, useRef, useState } from "react";

import CreatableSelect from "react-select/creatable";
import Select from "react-select";

import $ from "jquery";

import ModalContext from "./ModalContext";
import { payFactor } from "services/reservation";

function EditModals({ justShow = false }) {
  const {
    editModalData,
    editModalDynamicData,
    modalTourId,
    factorId,
    editModal,
    SMInfoHandler,
    MDDataHandler,
    saveFactor,
  } = useContext(ModalContext);

  const toggleRef = useRef();

  const [userOptions, setUserOptions] = useState([]);
  const [seats, setSeats] = useState([]);
  const [AC, setAC] = useState([]);

  function selectBuyer(value) {
    if (value.__isNew__) {
      let name = value.value.split(" ");
      if (name.length > 0)
        if (name.length > 1)
          SMInfoHandler("firstname", name[0], "lastname", name[1]);
        else SMInfoHandler("firstname", name[0]);
      toggleRef.current.click();
      value = { value: -1, label: value.label };
    }
    MDDataHandler("selectedUser", value);
  }

  async function selectEscorts(value) {
    let flag = false;
    value = value.map((val) => {
      if (val.__isNew__) {
        flag = true;
        let name = val.value.split(" ");
        if (name.length > 0)
          if (name.length > 1)
            SMInfoHandler("firstname", name[0], "lastname", name[1]);
          else SMInfoHandler("firstname", name[0]);
        return { value: -1, label: val.label };
      }
      return val;
    });
    if (flag) toggleRef.current.click();
    MDDataHandler("selectedEscort", value);
  }

  async function selectSeat(value) {
    value = value.map((val) => {
      return val;
    });
    if (value.length <= editModalDynamicData.selectedEscort.length + 1)
      MDDataHandler("seats", value);
  }

  function selectACHandler(value, index) {
    let x,
      flag = false;
    if (value === null) {
      x = editModalDynamicData.SAC.filter((val, ind) => index != ind);
    } else {
      let ac = editModalData.AC.find((val) => val.id == value.value);
      if (typeof ac === "undefined") return;
      x = editModalDynamicData.SAC.map((val, ind) => {
        if (ind == index) {
          flag = val.id == -1;
          val.id = ac.id;
          val.price = ac.cost;
          val.discount = 0;
          val.totalPrice =
            ac.cost * (editModalDynamicData.selectedEscort.length + 1);
        }
        return val;
      });
    }
    if ((flag && x.length != AC.length) || x.length == 0) {
      x.push({ id: -1, price: 0, discount: 0, totalPrice: 0 });
    }
    MDDataHandler("SAC", x);
  }

  useEffect(() => {
    setAC(
      editModalData.AC.reduce((total, value) => {
        if (value.tour_id == modalTourId) {
          return [
            ...total,
            {
              value: value.id,
              label: value.title,
            },
          ];
        } else return total;
      }, [])
    );
    setUserOptions(
      editModalData.users.map((value) => {
        return {
          value: value.id,
          label: `${value.fname} ${value.lname} - ${value.mobile}`,
        };
      })
    );
    let theSeats = [];
    console.log({ editModalDynamicData });
    if (editModalDynamicData.trasportType.includes("bus")) {
      if (editModalDynamicData.trasportType == "bus2") {
        theSeats = Array(25)
          .fill(0)
          .map((value, index) => index + 1);
      }
      if (editModalDynamicData.trasportType == "bus") {
        theSeats = Array(45)
          .fill(0)
          .map((value, index) => index + 1);
      }
      theSeats = theSeats.reduce((total, value) => {
        if (
          editModalDynamicData.seats.findIndex((val) => val.value == value) !==
          -1
        ) {
          return [
            ...total,
            {
              value: value,
              label: `صندلی شماره ${value}`,
            },
          ];
        }
        if (editModalData.seats.findIndex((val) => val == value) === -1) {
          return [
            ...total,
            {
              value: value,
              label: `صندلی شماره ${value}`,
            },
          ];
        }
        return total;
      }, []);
    }
    setSeats(theSeats);
  }, [editModalData, editModalDynamicData.trasportType, modalTourId, factorId]);

  return (
    <div
      class="modal fade text-black"
      id={justShow ? "show-reserve" : "add-edit-reserve"}
      tabindex="-1"
      aria-labelledby="Label"
      aria-hidden="true"
    >
      <div class="edit-tour-modal modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="Label">
              {justShow ? "جزئیات" : editModal ? "ویرایش" : "افزودن"} رزرو تور
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <button
              class="btn btn-primary d-none"
              ref={toggleRef}
              data-bs-dismiss="modal"
              data-bs-target="#sign-up-user"
              data-bs-toggle="modal"
            ></button>
          </div>
          <div class="modal-body">
            <div className="row align-items-center  my-3">
              <label className="col-12 col-lg-2">نام خریدار :</label>
              <div className="col-12 col-lg-9">
                <CreatableSelect
                  isDisabled={editModal || justShow}
                  onChange={selectBuyer}
                  value={
                    (editModal || justShow) &&
                    editModalDynamicData.selectedUser == null
                      ? { label: "", value: 0 }
                      : editModalDynamicData.selectedUser
                  }
                  options={userOptions.filter((value) => {
                    return (
                      editModalDynamicData.selectedEscort.findIndex(
                        (val) => val.value == value.value
                      ) == -1
                    );
                  })}
                />
              </div>
            </div>
            <div className="row align-items-center  my-3">
              <div className="col-12 col-lg-2">نام همراهان :</div>
              <div className="col-12 col-lg-9">
                <CreatableSelect
                  isMulti={
                    !justShow || editModalDynamicData.selectedEscort.length != 0
                  }
                  closeMenuOnSelect={false}
                  isDisabled={justShow}
                  onChange={selectEscorts}
                  value={
                    justShow && editModalDynamicData.selectedEscort.length == 0
                      ? { label: "", value: 0 }
                      : editModalDynamicData.selectedEscort
                  }
                  options={userOptions.filter((value) => {
                    return (
                      editModalDynamicData.selectedUser?.value != value.value &&
                      editModalDynamicData.selectedEscort.findIndex(
                        (val) => val.value == value.value
                      ) === -1
                    );
                  })}
                />
              </div>
            </div>
            {console.log({ trasportType: editModalDynamicData.trasportType })}
            {editModalDynamicData.trasportType.includes("bus") && (
              <div className="row align-items-center  my-3">
                <div className="col-12 col-lg-2">شماره صندلی :</div>
                <div className="col-12 col-lg-9">
                  <Select
                    isMulti={
                      !justShow ||
                      editModalDynamicData.selectedEscort.length != 0 ||
                      editModalDynamicData.seats.length != 0
                    }
                    closeMenuOnSelect={false}
                    isDisabled={justShow}
                    onChange={selectSeat}
                    value={
                      justShow && editModalDynamicData.seats.length == 0
                        ? { label: "", value: 0 }
                        : editModalDynamicData.seats
                    }
                    options={seats.filter(
                      (value) =>
                        editModalDynamicData.seats.findIndex(
                          (val) => val.value == value.value
                        ) == -1
                    )}
                  />
                </div>
              </div>
            )}
            <div className="d-flex flex-column">
              <div className="tables">
                <div className="item col-12 col-lg-6">
                  <div className="title">عنوان تور :</div>
                  <div className="description">
                    <input
                      type="text"
                      className="the-input form-control"
                      value={editModalDynamicData.tour.title}
                      disabled
                    />
                  </div>
                </div>
                <div className="item col-12 col-lg-6">
                  <div className="title">قیمت تور :</div>
                  <div className="description">
                    <input
                      type="number"
                      className="the-input form-control"
                      value={editModalDynamicData.tour.price}
                      disabled
                    />
                  </div>
                </div>
                <div className="item col-12 col-lg-6">
                  <div className="title">تخفیف :</div>
                  <div className="description">
                    <input
                      type="number"
                      className="the-input form-control"
                      min={0}
                      max={editModalDynamicData.tour.price}
                      value={editModalDynamicData.tourDiscount}
                      onChange={(e) =>
                        MDDataHandler("tourDiscount", e.target.value)
                      }
                      disabled={justShow}
                    />
                  </div>
                </div>
                <div className="item col-12 col-lg-6">
                  <div className="title">تعداد :</div>
                  <div className="description">
                    <input
                      type="number"
                      className="the-input form-control"
                      disabled
                      value={editModalDynamicData.selectedEscort.length + 1}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <div className="my-3 col-12 col-md-6 col-lg-4">
                  <div className="input-group">
                    <span className="input-group-text">جمع کل:</span>
                    <input
                      type="number"
                      className="form-control"
                      disabled
                      value={editModalDynamicData.tourPrice}
                    />
                  </div>
                </div>
              </div>
            </div>
            {AC.length > 0 ? (
              <>
                <hr style={{ lineHeight: 3 }} />
                {/* هزینه های اضافی */}
                <div className="text-center">
                  <div className="fw-bold">هزینه های اضافی</div>
                </div>

                {editModalDynamicData.SAC.map((value, index) => (
                  <div className={`tables`}>
                    <div
                      className={`item col-12 ${
                        value.id != -1 ? "col-lg-6" : ""
                      }`}
                    >
                      <div className="title">عنوان تور</div>
                      <div className="description">
                        <Select
                          isClearable
                          isRtl
                          value={AC.find((v) => v.value == value.id)}
                          options={AC.filter((v) => {
                            if (
                              typeof editModalDynamicData.SAC.find(
                                (val) => val.id == v.value
                              ) === "undefined"
                            )
                              return true;
                            return false;
                          })}
                          onChange={(val) => selectACHandler(val, index)}
                        />
                      </div>
                    </div>
                    {value.id != -1 ? (
                      <>
                        <div className="item col-12 col-lg-6">
                          <div className="title">قیمت واحد</div>
                          <div className="description">
                            <input
                              type="number"
                              className="form-control the-input"
                              disabled
                              value={value.price}
                            />
                          </div>
                        </div>
                        <div className="item col-12 col-lg-6">
                          <div className="title"> تخفیف </div>
                          <div className="description">
                            <input
                              type="number"
                              className="form-control the-input"
                              disabled={justShow || value.id == -1}
                              min={0}
                              max={value.price}
                              value={value.discount}
                              onChange={(e) => {
                                MDDataHandler(
                                  "SAC",
                                  editModalDynamicData.SAC.map((val, ind) => {
                                    if (ind == index) {
                                      let x =
                                        (val.price - e.target.value) *
                                        (selectEscorts.length + 1);
                                      return {
                                        ...val,
                                        discount: e.target.value,
                                        totalPrice: x > 0 ? x : 0,
                                      };
                                    }
                                    return val;
                                  })
                                );
                              }}
                            />
                          </div>
                        </div>
                        <div className="item col-12 col-lg-6">
                          <div className="title"> تعداد </div>
                          <div className="description">
                            <input
                              type="number"
                              className="form-control the-input"
                              disabled
                              value={
                                editModalDynamicData.selectedEscort.length + 1
                              }
                            />
                          </div>
                        </div>
                        <div className="item col-12">
                          <div className="title"> مجموع </div>
                          <div className="description">
                            <input
                              type="number"
                              className="form-control the-input"
                              disabled
                              value={value.totalPrice}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
                <div className="d-flex justify-content-end mt-3">
                  <div className="col-12 col-md-6 col-xl-3">
                    <div className="input-group ">
                      <div className="input-group-text"> جمع کل :</div>
                      <input
                        type="number"
                        className="col-12 col-md-8 form-control"
                        disabled
                        value={editModalDynamicData.totalPrice}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              انصراف
            </button>
            <button
              type="button"
              class="btn btn-primary"
              disabled={
                editModalDynamicData.selectedUser == null ||
                (editModalDynamicData.trasportType.includes("bus") &&
                  editModalDynamicData.seats.length !=
                    editModalDynamicData.selectedEscort.length + 1)
              }
              data-bs-dismiss="modal"
              onClick={saveFactor}
            >
              {factorId > 0 ? "ثبت ویرایش" : "ثبت رزرو"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function SignupUserModal() {
  const { signupModalInfo, editModal, editModalData, SMInfoHandler, addUser } =
    useContext(ModalContext);

  const modalRef = useRef();
  const toggleRef = useRef();

  const [handlerSaver, setHandlerSaver] = useState();

  const handler = () => {
    addUser(true);
    let x = $("#add-edit-reserve");
    x.show();
    x.addClass("show");
    modalRef.current.removeEventListener("hidden.bs.modal", handlerSaver.func);
    toggleRef.current.click();
  };

  useEffect(() => {
    if (handlerSaver)
      modalRef.current.removeEventListener(
        "hidden.bs.modal",
        handlerSaver.func
      );
    setHandlerSaver({ func: handler });
    modalRef.current.addEventListener("hidden.bs.modal", handler);
  }, [editModal, editModalData]);

  return (
    <>
      <div
        className="modal fade"
        ref={modalRef}
        id="sign-up-user"
        tabindex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered the-modal1">
          <div className="modal-content">
            <div className="modal-header d-none">
              <button
                ref={toggleRef}
                class="btn btn-warning"
                data-bs-target={"#add-edit-reserve"}
                data-bs-toggle="modal"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body p-5">
              <div className="row">
                <label
                  for="firstname"
                  className="mb-3 col-12 col-sm-4 col-lg-1 col-form-label"
                >
                  نام
                </label>
                <div className="mb-3 col-12 col-sm-6 col-lg-2">
                  <input
                    type="text"
                    className="form-control"
                    id="firstname"
                    value={signupModalInfo.firstname}
                    onChange={(e) => SMInfoHandler("firstname", e.target.value)}
                  />
                </div>
                <label
                  for="lastname"
                  className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
                >
                  نام خانوادگی
                </label>
                <div className="mb-3 col-12 col-sm-6 col-lg-3">
                  <input
                    type="text"
                    className="form-control"
                    id="lastname"
                    value={signupModalInfo.lastname}
                    onChange={(e) => SMInfoHandler("lastname", e.target.value)}
                  />
                </div>
                <label
                  for="code"
                  className="mb-3 col-12 col-sm-4 col-lg-1 col-form-label"
                >
                  کدملی
                </label>
                <div className="mb-3 col-12 col-sm-6 col-lg-3">
                  <input
                    type="text"
                    className="form-control"
                    id="code"
                    value={signupModalInfo.code}
                    onChange={(e) => SMInfoHandler("code", e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <label
                  for="phone"
                  className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
                >
                  شماره تماس
                </label>
                <div className="mb-3 col-12 col-sm-6 col-lg-4">
                  <input
                    type="text"
                    className="form-control"
                    id="phone"
                    value={signupModalInfo.phone}
                    onChange={(e) => SMInfoHandler("phone", e.target.value)}
                  />
                </div>
                <div className="row justify-content-evenly">
                  <button
                    class="col-12 col-sm-5 col-lg-3 btn btn-warning the-btn1"
                    data-bs-dismiss="modal"
                  >
                    بازگشت{" "}
                  </button>
                  <button
                    type="button"
                    className="col-12 col-sm-5 col-lg-3 btn btn-primary the-btn1"
                    data-bs-dismiss="modal"
                    onClick={() => addUser()}
                  >
                    ثبت
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function PayModal() {
  const { payModalData } = useContext(ModalContext);
  const [price, setPrice] = useState();

  function pay() {
    payFactor(payModalData.factorId, price);
  }

  useEffect(() => {
    setPrice(payModalData.price);
  }, [payModalData]);

  return (
    <div
      class="modal fade"
      id="payModal"
      tabindex="-1"
      aria-labelledby="payModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="payModalLabel">
              مودال درخواست تکمیل وجه
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div className="form-floating mb-3">
              <input
                className="form-control"
                id="thePayPrice"
                type="number"
                placeholder="number"
                max={payModalData.price}
                min={0}
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
              <label id="thePayPrice" for="floatingInput">
                مبلغ مورد نظر جهت پرداخت
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              منصرف شدم
            </button>
            <button type="button" class="btn btn-primary">
              ارسال لینک پرداخت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export { EditModals, SignupUserModal, PayModal };
